// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2l_q5","rootSmall":"AddTileButton_rootSmall__1fdN7"};